@if (showDefinition()) {
    <button
        qpxButton="unstyled"
        data-building-identity-definition-trigger
        style="color: inherit; text-transform: inherit"
        class="inline-flex h-5 min-w-5 shrink-0 items-center justify-center gap-1 rounded-sm p-0 leading-none focus-visible:outline-2 focus-visible:outline-offset-2"
        [attr.aria-label]="
            iconOnly() && value()
                ? `About ${label()}: ${value()}`
                : `About ${label()}`
        "
        aria-haspopup="dialog"
        [attr.aria-expanded]="definitionPopover.isOpen()"
        (click)="onClick('definition', $event)"
        (focusout)="onFocusOut('definition', $event)"
    >
        @if (definitionTriggerLabel()) {
            <span>{{ definitionTriggerLabel() }}</span>
        }
        <ng-icon qpx [size]="iconSize()" [name]="icon()" />
    </button>
}
@if (!iconOnly()) {
    <span
        [qpxCell]="muted() ? 'secondary' : undefined"
        [tone]="muted() ? 'muted' : 'default'"
        variant="sm"
        class="min-w-0 truncate"
    >
        {{ value() }}
    </span>
    @if (showSource()) {
        <button
            qpxButton="unstyled"
            data-building-identity-source-trigger
            class="inline-flex h-5 min-w-5 shrink-0 items-center justify-center gap-1 rounded-sm p-0 leading-none focus-visible:outline-2 focus-visible:outline-offset-2"
            [attr.aria-label]="`Source for ${label()}: ${sourceLabel()}`"
            aria-haspopup="dialog"
            [attr.aria-expanded]="sourcePopover.isOpen()"
            (click)="onClick('source', $event)"
            (focusout)="onFocusOut('source', $event)"
        >
            <qpx-pill
                size="sm"
                [icon]="sourceIcon()"
                [label]="sourceLabel()"
                [context]="sourceContext()"
                tone="muted"
                [decorative]="true"
                [darkenIconBackground]="true"
                [iconOnly]="true"
            />
        </button>
    }
}
